import type { Host } from '@interfaces/host.interface';

import { HOST_NAMES, TIMEZONES, ZIP_CODES } from '../pools';
import { pick, randomInt, uuid } from '../utils';

export function buildHost(overrides?: Partial<Host>): Host {
  return {
    id: uuid(),
    name: pick(HOST_NAMES),
    currency: 'EUR',
    unit: 'METRIC',
    zone: pick(TIMEZONES),
    contactPersonId: uuid(),
    bookingCutOffDate: '2',
    location: {
      address: 'Calle Principal 1',
      city: 'Barcelona',
      state: 'Barcelona',
      country: 'Spain',
      zipCode: pick(ZIP_CODES),
      coordinates: { latitude: 41.3851, longitude: 2.1734 },
    },
    totalRentals: randomInt(3, 12),
    ...overrides,
  };
}
